let shim;

export function setFirebaseShim(firebase) {
  shim = firebase;
}

export function firebaseShim() {
  return shim;
}
